export default __webpack_public_path__ + "media/zurb/img/about/about-img1-a8fbe1a674cff9bcfe8c417a896398b6.png";